import { GridItem } from '@chakra-ui/react';
import { FC, Fragment, ReactNode, useEffect } from 'react';

import { useLecturePageQueryParams } from '@/components/ui/features/lecture/hooks';
import { LectureMediaLock } from '@/components/ui/features/lecture/LecturePlayer/components/LectureMediaLock';
import { queryThinLectureWithTagAndEvent } from '@/fetchers/thinLectures';
import { useLibLynx } from '@/hooks/useLibLynx';
import { useResource } from '@/lib/datx-jsonapi-react';
import { queryLectureAccessPermission } from '@/queries/lecture-access-permissions';
import { ILibLynxMetadata } from '@/types/LibLynx';

interface ILectureRestrictionProps {
  children: ReactNode;
}

export const LectureRestriction: FC<ILectureRestrictionProps> = ({ children }) => {
  const { id: lectureId } = useLecturePageQueryParams();
  const { data: lecture } = useResource(queryThinLectureWithTagAndEvent(lectureId));
  const libLynx = useLibLynx();

  const { data } = useResource(queryLectureAccessPermission(lectureId));

  const isLectureRestricted = data?.restricted;

  useEffect(() => {
    const libLynxMetadata: ILibLynxMetadata = {
      title: lecture.title,
      dtype: 'multimedia',
      doi: lecture.doi,
    };

    if (isLectureRestricted) {
      libLynx.send('trackDenial', { deny: 'No_license', tm: libLynxMetadata });
    } else {
      libLynx.send('trackItemInvestigation', { tm: libLynxMetadata });
    }
  }, [lectureId, isLectureRestricted, libLynx.send]);

  if (isLectureRestricted) {
    return (
      <GridItem position="relative" gridRowStart="1" gridRowEnd="auto" gridColumnStart="1" gridColumnEnd="auto">
        <LectureMediaLock />
      </GridItem>
    );
  }

  return <Fragment>{children}</Fragment>;
};
